// Aakash Drishti brand mark - clean SVG (orbit + focal dot).
import React from 'react';

export function LogoMark({ size = 28, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
         className={className} aria-label="Aakash Drishti">
      <ellipse cx="16" cy="16" rx="13" ry="5.5" transform="rotate(-24 16 16)"
               stroke="currentColor" strokeWidth="1.75" opacity="0.7" />
      <ellipse cx="16" cy="16" rx="10" ry="10" stroke="currentColor" strokeWidth="1.25" opacity="0.25" />
      <circle cx="16" cy="16" r="3.4" fill="currentColor" />
      <circle cx="27" cy="9" r="1.8" fill="currentColor" />
    </svg>
  );
}

// Primary desktop wordmark. Includes the mandated "A product by Any Tech Ventures Pvt. Ltd."
// attribution under the product name so it is visible in the header on
// enterprise viewports without overpowering the Aakash Drishti identity.
export function Wordmark({ className = '', showAttribution = true }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={30} className="text-primary shrink-0" />
      <div className="leading-none">
        <div className="font-display font-semibold text-[16px] tracking-tight" data-testid="brand-product-name">
          Aakash Drishti
        </div>
        <div className="text-[9px] uppercase tracking-[0.16em] text-muted-foreground mt-0.5">
          Satellite Intelligence for Critical Infrastructure
        </div>
        {showAttribution && (
          <div className="text-[10px] text-muted-foreground mt-1" data-testid="brand-atv-attribution">
            A product by{' '}
            <a
              href="https://anytechventures.com/"
              target="_blank"
              rel="noreferrer"
              className="text-foreground/80 hover:text-primary underline underline-offset-2 decoration-dotted font-medium"
              data-testid="brand-atv-link"
            >
              Any Tech Ventures Pvt. Ltd.
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export function WordmarkStacked({ className = '' }) {
  return (
    <div className={`flex flex-col items-center gap-3 ${className}`}>
      <LogoMark size={44} className="text-primary" />
      <div className="text-center">
        <div className="font-display font-semibold text-2xl tracking-tight">Aakash Drishti</div>
        <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground mt-1">
          Satellite Intelligence Platform
        </div>
        <div className="text-[10px] text-muted-foreground mt-2">
          A product by{' '}
          <a
            href="https://anytechventures.com/"
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-2 decoration-dotted hover:text-primary"
          >
            Any Tech Ventures Pvt. Ltd.
          </a>
        </div>
      </div>
    </div>
  );
}
